import request from '@/utils/request'
import { btcguid } from '@/utils/validate'
import { getToken } from '@/utils/auth'

export default {
  getNews: function(params) {
    return request({
      url: '/GetFrontNews',
      method: 'post',
      data: {
        MessageType: 2001,
        MessageID: btcguid(),
        Data: {
          NewsType: params.NewsType,
          PageNum: params.pageNum,
          PageSize: params.pageSize,
          IsHot: params.isHot,
          IsTopNews: params.isTopNews,
          Countury: params.countury,
          Type: params.type,
          NewsLanguageCode: params.newsLanguageCode,
          Continent: params.continent,
          KeyWords: params.KeyWords,
          SubType: params.SubType
        }
      }
    })
  },

  getHotNews: function(params) {
    return request({
      url: '/GetFrontHotNews',
      method: 'post',
      data: {
        MessageType: 2002,
        MessageID: btcguid(),
        Data: {
          Type: params.type,
          NewsLanguageCode: params.newsLanguageCode
        }
      }
    })
  },

  getNewsDetail: function(newsID) {
    return request({
      url: '/GetFrontNewsDetail',
      method: 'post',
      headers: {
        'Authorization': getToken()
      },
      data: {
        MessageType: 2003,
        MessageID: btcguid(),
        Data: {
          NewsID: newsID
        }
      }
    })
  },

  getNewsSummary: function(newsID) {
    return request({
      url: '/GetNewsSummary',
      method: 'post',
      data: {
        MessageType: 2004,
        MessageID: btcguid(),
        Data: {
          NewsID: newsID
        }
      }
    })
  },

  getExchangeRate: function(target) {
    return request({
      url: '/GetExchangeRate',
      method: 'post',
      data: {
        MessageType: 2005,
        MessageID: btcguid(),
        Data: {
          TargetCurrency: target
        }
      }
    })
  },
  getFrontMarketIndex: function(params) {
    return request({
      url: '/GetFrontMarketIndex',
      method: 'post',
      data: {
        MessageType: 2006,
        MessageID: btcguid(),
        Data: {
          Type: params.Type,
          Part: params.Part,
          Country: params.Country
        }
      }
    })
  },
  addUserFinalPrice: function(params) {
    return request({
      url: '/AddUserFinalPrice',
      method: 'post',
      data: {
        MessageType: 2007,
        MessageID: btcguid(),
        Data: {
          OriginPlace: params.Country,
          Part: params.Part,
          FinalPrice: params.Price,
          UserID: params.UserID,
          SourceSection: params.SourceSection,
          BeefPriceDataID: params.BeefPriceDataID,
          SourceSectionName: params.SourceSectionName,
          SourceType: params.SourceType,
          PriceNature: params.PriceNature,
          Quantity: params.Quantity,
          Warehouse: params.Warehouse,
          PlantNo: params.PlantNo,
          ExpireDate: params.ExpireDate
        }
      }
    })
  },
  getFrontMarketReport: function(params) {
    return request({
      url: '/GetFrontMarketReport',
      method: 'post',
      data: {
        MessageType: 2008,
        MessageID: btcguid(),
        Data: {
          PageNum: params.pageNum,
          PageSize: params.pageSize,
          ReportType: params.ReportType,
          LanguageCode: params.LanguageCode
        }
      }
    })
  },
  getFrontMarketReportDetail: function(params) {
    return request({
      url: '/GetFrontMarketReportDetail',
      method: 'post',
      data: {
        MessageType: 2009,
        MessageID: btcguid(),
        Data: {
          ReportID: params.ReportID,
          OriginPlace: params.OriginPlace,
          Part: params.Part,
          District: params.District,
          Level: params.Level
        }
      }
    })
  },
  getUserMarketPriceData: function(params) {
    return request({
      url: '/GetUserMarketPriceData',
      method: 'post',
      headers: {
        'Authorization': getToken()
      },
      data: {
        MessageType: 2010,
        MessageID: btcguid(),
        Data: {
          PageNum: params.PageNum,
          PageSize: params.PageSize,
          OriginPlace: params.OriginPlace,
          Part: params.Part
          // BeefPriceDataID: params.BeefPriceDataID
        }
      }
    })
  },
  addFrontUserFinalPrice: function(params) {
    return request({
      url: '/AddFrontUserFinalPrice',
      method: 'post',
      data: {
        MessageType: 2011,
        MessageID: btcguid(),
        Data: {
          OriginPlace: params.Country,
          Part: params.Part,
          FinalPrice: params.Price,
          UserID: params.UserID,
          SourceSection: params.SourceSection,
          BeefPriceDataID: params.BeefPriceDataID,
          SourceSectionName: params.SourceSectionName,
          SourceType: params.SourceType,
          PriceNature: params.PriceNature,
          Quantity: params.Quantity,
          Warehouse: params.Warehouse,
          PlantNo: params.PlantNo,
          ExpireDate: params.ExpireDate,
          FeedingMode: params.FeedingMode,
          Level: params.Level
        }
      }
    })
  },
  getCurrentUserMarketPriceData: function(params) {
    return request({
      url: '/GetCurrentUserMarketPriceData',
      method: 'post',
      headers: {
        'Authorization': getToken()
      },
      data: {
        MessageType: 2012,
        MessageID: btcguid(),
        Data: {
          PageNum: params.PageNum,
          PageSize: params.PageSize,
          Part: params.Part,
          OriginPlace: params.OriginPlace
          // BeefPriceDataID: params.BeefPriceDataID
        }
      }
    })
  },
  getImportLevel: function(params) {
    return request({
      url: '/GetImportLevel',
      method: 'post',
      headers: {
        'Authorization': getToken()
      },
      data: {
        MessageType: 2013,
        MessageID: btcguid(),
        Data: {}
      }
    })
  },
  getFrontReportPermission: function(params) {
    return request({
      url: '/GetFrontReportPermission',
      method: 'post',
      headers: {
        'Authorization': getToken()
      },
      data: {
        MessageType: 2014,
        MessageID: btcguid(),
        Data: {
          IsRead: params.IsRead,
          ReportID: params.ReportID
        }
      }
    })
  },
  checkFrontUserFinalPriceState: function(params) {
    return request({
      url: '/CheckFrontUserFinalPriceState',
      method: 'post',
      headers: {
        'Authorization': getToken()
      },
      data: {
        MessageType: 2015,
        MessageID: btcguid(),
        Data: {
          Part: params.Part,
          OriginPlace: params.OriginPlace
        }
      }
    })
  },
  getFrontReportEnPermission: function(params) {
    return request({
      url: '/GetFrontReportEnPermission',
      method: 'post',
      headers: {
        'Authorization': getToken()
      },
      data: {
        MessageType: 2016,
        MessageID: btcguid(),
        Data: {
          IsRead: params.IsRead,
          ReportID: params.ReportID
        }
      }
    })
  },
  getFrontMarketMultiIndex: function(params) {
    return request({
      url: '/GetFrontMarketMultiIndex',
      method: 'post',
      headers: {
        'Authorization': getToken()
      },
      data: {
        MessageType: 2017,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID,
          Type: params.Type,
          Part: params.Part,
          Country: params.Country,
          IsFirst: params.IsFirst,
          LanguageCode: params.LanguageCode
        }
      }
    })
  },
  getPriceDataList: function(params) {
    return request({
      url: '/GetPriceDataList',
      method: 'post',
      data: {
        MessageType: 2018,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID,
          ReportID: params.ReportID,
          OriginPlace: params.OriginPlace,
          Part: params.Part,
          Level: params.Level
        }
      }
    })
  },
  getPriceVaildDate: function(params) {
    return request({
      url: '/GetPriceVaildDate',
      method: 'post',
      data: {
        MessageType: 2019,
        MessageID: btcguid(),
        Data: {
          ReportType: params.ReportType,
          LanguageCode: params.LanguageCode
        }
      }
    })
  },
  marketPriceTrial: function(params) {
    return request({
      url: '/MarketPriceTrial',
      method: 'post',
      data: {
        MessageType: 2020,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID,
          ReportID: params.ReportID,
          isEn: params.isEn
        }
      }
    })
  },
  getFrontPriceDictionary: function(params) {
    return request({
      url: '/GetFrontPriceDictionary',
      method: 'post',
      data: {
        MessageType: 2021,
        MessageID: btcguid(),
        Data: {
          BeefPriceKeyType: params.BeefPriceKeyType,
          BeefPriceKeyParent: params.BeefPriceKeyParent,
          BeefPriceKeySecondParent: params.BeefPriceKeySecondParent
        }
      }
    })
  },
  getAppNewsDetail: function(params) {
    return request({
      url: '/GetAppNewsDetail',
      method: 'post',
      data: {
        MessageType: 2022,
        MessageID: btcguid(),
        Data: {
          NewsID: params.NewsID,
          IsShare: params.IsShare
        }
      }
    })
  },
  getSimilarArticle: function(params) {
    return request({
      url: '/GetSimilarArticle',
      method: 'post',
      data: {
        MessageType: 2023,
        MessageID: btcguid(),
        Data: {
          NewsID: params.NewsID
        }
      }
    })
  },
  getPriceDataIndex: function(params) {
    return request({
      url: '/GetPriceDataIndex',
      method: 'post',
      data: {
        MessageType: 2024,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID,
          Part: params.Part,
          Country: params.Country,
          FeedingMode: params.FeedingMode,
          Type: params.Type,
          IsEn: params.IsEn
        }
      }
    })
  },
  getAppNewsAnalysis: function(params) {
    return request({
      url: '/GetAppNewsAnalysis',
      method: 'post',
      data: {
        MessageType: 2025,
        MessageID: btcguid(),
        Data: {
          Year: params.Year,
          PageNum: params.PageNum,
          PageSize: params.PageSize,
          UserID: params.UserID
        }
      }
    })
  },
  getFrontNewsPermission: function(params) {
    return request({
      url: '/GetFrontNewsPermission',
      method: 'post',
      headers: {
        'Authorization': getToken()
      },
      data: {
        MessageType: 2014,
        MessageID: btcguid(),
        Data: {
          IsRead: params.IsRead,
          NewsID: params.NewsID
        }
      }
    })
  },
  getFrontMarketNewsDetail: function(params) {
    return request({
      url: '/GetFrontMarketNewsDetail',
      method: 'post',
      data: {
        MessageType: 2009,
        MessageID: btcguid(),
        Data: {
          NewsID: params.NewsID,
          UserID: params.UserID
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/news.js